import { TJsonQueryKeys, TJsonQueryOptionalKeys } from '../../../packages/JsonQuery';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { NON_RESETTABLE_FILTERS } from '../constants/activeFilters';

/**
 * Получает список всех фильтров, которые можно сбросить.
 * Исключает поля из NON_RESETTABLE_FILTERS.
 */
export function getResettableFilters(jsonQuery: IJsonQuery): TJsonQueryOptionalKeys[] {
  const allKeys = Object.keys(jsonQuery) as TJsonQueryKeys[];

  return allKeys.filter(
    (key): key is TJsonQueryOptionalKeys =>
      !NON_RESETTABLE_FILTERS.includes(key) && jsonQuery[key as keyof IJsonQuery] !== undefined,
  );
}
